<template>
  <div class="panel">
      <q-tabs
        v-model="tab"
        dense
        class="text-grey"
        active-color="black"
        indicator-color="black"
        align="justify"
        narrow-indicator
      >
        <q-tab v-if="showTabHome" name="home" :label="$t('tools.home.headerName')"></q-tab>
        <q-tab v-if="showTabCatalog" name="catalog" :label="$t('tools.catalog.headerName')"></q-tab>
        <q-tab v-if="showTabTools" name="tools" :label="$t('names.tools')"></q-tab>
      </q-tabs>
      <q-separator />
      <q-tab-panels v-model="tab" animated style="background-color: transparent">
        <q-tab-panel name="home">
          <div class="panel-title">
            <slot name="title">
              Mapia Geoportal
            </slot>
          </div>
          <slot name="description">
            <p>
              Aquesta aplicació et permetrà navegar, consultar i mesurar tots el núvols de punts:
              Mesurar distàncies, àrees, alçades, extreure coordenades, crear perfils, exportar LAS, mesurar angles, consultar classificacions...
            </p>
          </slot>
          <div class="row flex-center q-py-md  q-gutter-xs" v-show="themes && themes.length > 0">
            <div v-for="theme in themes" :key="theme.name">
              <q-btn
                dense stack no-caps outline color="grey-9"
                class="col"
                style="width: 100px"
                @click="setTheme(theme)"
              >
                <div>
                <q-avatar square style="width: 100%; height: 100%;">
                  <img :src="theme.img" style="height: 90px; width: 90px; object-fit: cover">
                </q-avatar>
                </div>
                <div :id="theme.name" style="font-size: 12px; line-height: 14px" class="q-pt-xs">{{ theme.label }}</div>
                <q-tooltip v-if="theme.tooltip">{{ theme.tooltip }}</q-tooltip>
              </q-btn>
            </div>
          </div>
          <div class="q-pb-md" v-show="$config.layout.home.showCadastreBtn">
            <q-toggle
              v-model="cadastre"
              :label="$t('actions.activateCadasterLayer')"
            />
          </div>
          <div v-if="$config.layout.home.baseLayerOptions">
            <div class="text-subtitle1">{{ $t('names.baseMap') }}</div>
            <div class="q-py-md">
              <q-btn-toggle
                v-model="cartoOrto"
                no-caps
                rounded
                unelevated
                toggle-color="grey-8"
                color="white"
                text-color="grey-8"
                style="border: 1px solid"
                :options="$config.layout.home.baseLayerOptions"
              />
            </div>
          </div>
          <slot name="footer">
            <div class="q-pa-lg text-center"></div>
          </slot>
        </q-tab-panel>
        <q-tab-panel name="catalog">
          <catalog-panel style="margin: -20px -15px -15px -15px;"/>
        </q-tab-panel>
        <q-tab-panel name="tools">
          <tools-panel style="margin: -20px -15px -15px -15px;"/>
        </q-tab-panel>
      </q-tab-panels>
  </div>
</template>

<script>
import ToolsPanel from './Home/ToolsPanel.vue'
import { QAvatar, QBtn, QBtnToggle, QToggle, QTab, QTabs, QTabPanel, QTabPanels, QTooltip, QSeparator } from 'quasar'
import CatalogPanel from './CatalogPanel.vue'
import { cadastreLayer } from 'src/constants.js'

export default {
  name: 'HomePanel',
  props: {
    showTabHome: {
      type: Boolean,
      default: true,
      required: false
    },
    showTabCatalog: {
      type: Boolean,
      default: true,
      required: false
    },
    showTabTools: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  components: {
    QAvatar,
    QBtn,
    QBtnToggle,
    QToggle,
    QTab,
    QTabs,
    QTabPanel,
    QTabPanels,
    QTooltip,
    QSeparator,
    CatalogPanel,
    ToolsPanel
  },
  data () {
    return {
      cadastre: false
    }
  },
  beforeRouteEnter: CatalogPanel.beforeRouteEnter,
  beforeRouteUpdate: CatalogPanel.beforeRouteUpdate,
  computed: {
    tab: {
      get () {
        return this.$store.state.layout.homeTab
      },
      set (value) {
        this.$store.commit('layout/setHomeTab', value)
      }
    },
    cartoOrto: {
      get () {
        return (this.$store.state.map.layers && this.$store.state.map.layers.baseLayer && this.$store.state.map.layers.baseLayer.name) || 'Mapa base ICGC (gris)'
      },
      set (value) {
        const baseMap = this.$config.basemaps.findIndex(map => map.name === value)
        this.$store.dispatch('map/setBaseLayer', baseMap)
      }
    },
    themes () {
      return this.$config.layout.home.themes.filter(theme => {
        return !theme.supported || theme.supported.call(this, theme)
      })
    }
  },
  methods: {
    removeAllLayers () {
      const overlays = [...this.$store.state.map.layers.overlays]
      overlays.forEach(layer => {
        if (layer.id.plainRef !== cadastreLayer.id.plainRef) {
          this.$store.dispatch('map/removeOverlay', layer)
        }
      })
    },
    async setTheme (theme) {
      if (!theme.keepLayers) {
        this.removeAllLayers()
      }
      if (theme.layers) {
        const layersToAdd = []

        for (let index = 0; index < theme.layers.length; index++) {
          const layer = theme.layers[index]

          if (layer.id === cadastreLayer.id) {
            this.cadastre = true
          }
          if (layer.id?.plainRef) {
            try {
              const result = await layer.id.getAsResult(1, this)
              layersToAdd.push({ result, index, isOverlay: true })
            } catch (error) {
              console.error(`Error processing layer at index ${index}:`, error)
            }
          } else {
            layersToAdd.push({ layer, index, isOverlay: false })
          }
        }

        for (const item of layersToAdd) {
          if (item.isOverlay) {
            await this.$store.dispatch('map/addOverlay', item.result)
          } else {
            await this.$store.dispatch('map/addLayer', item.layer)
          }
        }
      }
      if (theme.baseMap) {
        this.cartoOrto = theme.baseMap
      }
      if (theme.to) {
        this.$router.push({ name: theme.to })
      } else if (theme.url) {
        window.open(theme.url)
      }
      if (theme.action) {
        theme.action.call(this)
      }
    },
    setEntorn3d () {
      this.$router.push({ name: 'panorama' })
    },
    vinculateCadastre () {
      if (this.cadastre) {
        this.$store.dispatch('map/addLayer', cadastreLayer)
      } else {
        const overlay = this.$store.state.map.layers.overlays.filter(layer => layer.id === cadastreLayer.id)
        if (overlay.length > 0) {
          this.$store.dispatch('map/removeOverlay', overlay[0])
        }
      }
    }
  },
  watch: {
    cadastre: 'vinculateCadastre'
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #206AB6;
}
p.backToMain {
  font-size: 16px;
}
</style>
